export var EdelweissAssetClass;
(function (EdelweissAssetClass) {
    EdelweissAssetClass["EQUITY"] = "Equity Related";
    EdelweissAssetClass["FI"] = "Fixed Income";
    EdelweissAssetClass["MP"] = "Managed Portfolio";
    EdelweissAssetClass["CO"] = "Commodity";
    EdelweissAssetClass["RE"] = "Real Estate";
})(EdelweissAssetClass || (EdelweissAssetClass = {}));
export var MangedPortfolioComposition;
(function (MangedPortfolioComposition) {
    MangedPortfolioComposition["MF"] = "MF";
    MangedPortfolioComposition["AIF"] = "AIF";
    MangedPortfolioComposition["PMS"] = "PMS";
    MangedPortfolioComposition["ETF"] = "ETF";
    MangedPortfolioComposition["StructuredProducts"] = "SP";
    MangedPortfolioComposition["INVITS"] = "INVITS";
})(MangedPortfolioComposition || (MangedPortfolioComposition = {}));
export var MutualFundComposition;
(function (MutualFundComposition) {
    MutualFundComposition["EQUITY"] = "Equity";
    MutualFundComposition["HYBRID"] = "Hybrid";
    MutualFundComposition["DEBT"] = "Debt";
    MutualFundComposition["OTHER"] = "Other";
})(MutualFundComposition || (MutualFundComposition = {}));
export var FixedIncomeComposition;
(function (FixedIncomeComposition) {
    FixedIncomeComposition["Bonds"] = "BO";
    FixedIncomeComposition["NCD"] = "NCD";
    FixedIncomeComposition["CertOfDeposit"] = "COD";
    FixedIncomeComposition["CommPaper"] = "CP";
    FixedIncomeComposition["Warrant"] = "W";
    FixedIncomeComposition["Debentures"] = "DB";
    FixedIncomeComposition["IndianDepoReceipt"] = "IDR";
    FixedIncomeComposition["PreferenceShare"] = "PS";
    FixedIncomeComposition["CorpFD"] = "CFD";
    FixedIncomeComposition["RBIBonds"] = "RBO";
    FixedIncomeComposition["EC54"] = "54EC";
})(FixedIncomeComposition || (FixedIncomeComposition = {}));
export const productCodeValues = [
    ...Object.values(FixedIncomeComposition),
    ...Object.values(MangedPortfolioComposition),
];
